import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

export interface DisbursementItem {
  id: number;
  vesselName: string;
  port: string;
  arrivalDate: string;
  initialAmount: number;
  negotiatedAmount: number;
  savings: number;
  disbursementId: string;
  type: 'pda_negotiation' | 'fda_negotiation';
}

@Component({
  selector: 'app-testing-page',
  templateUrl: './testing-page.component.html',
  styleUrls: ['./testing-page.component.scss'],
})
export class TestingPageComponent implements OnInit {
  @ViewChild('modalContainer') modalContainer!: ElementRef;
  @ViewChild('tableSection') tableSection!: ElementRef;

  showSavingsPopup = false;
  savingsPopupType: 'pda' | 'fda' | 'overall' = 'overall';
  selectedSavingSource: 'pda_negotiation' | 'fda_negotiation' | null = null;
  showAllRows = false;

  savingsData = {
    pdaEstimatedBudget: 124995,
    fdaUtilizedAmount: 120000,
    overallSavingsAmount: 4995,
    pdaSavingsAmount: 3200,
    fdaSavingsAmount: 1795,
    totalPortCalls: 45,
    budgetUtilizedPercentage: 96.0,
    avgDisbursementPerCall: 2666.67,
    oneDayDelta: 49.84,
    oneDayDeltaPercentage: 0.04,
    shortTermPortCallsAmount: 120000,
    efficiencyRate: 41.2,
    pdaTariffBudget: 37100,
    pdaTariffFDAUtilized: 35000,
    pdaTariffSavings: 2100, // Card 1 Total Savings: $2,100
    fdaVoucherBudget: 29200,
    fdaVoucherUtilized: 28000,
    fdaVoucherSavings: 1200, // Card 2 Total Savings: $1,200
  };

  // Adjusted row savings so the sum matches the exact card totals
  tableData: DisbursementItem[] = [
    // --- PDA ITEMS (Sum of savings = $2,100) ---
    { id: 1, vesselName: 'M/V Ocean Star', port: 'Singapore', arrivalDate: '2026-08-01', initialAmount: 3500, negotiatedAmount: 3200, savings: 300, disbursementId: 'MDA894', type: 'pda_negotiation' },
    { id: 2, vesselName: 'M/V Pioneer Express', port: 'Rotterdam', arrivalDate: '2026-08-03', initialAmount: 2800, negotiatedAmount: 2600, savings: 200, disbursementId: 'MDA895', type: 'pda_negotiation' },
    { id: 3, vesselName: 'M/V Baltic Breeze', port: 'Hamburg', arrivalDate: '2026-08-04', initialAmount: 4200, negotiatedAmount: 3950, savings: 250, disbursementId: 'MDA896', type: 'pda_negotiation' },
    { id: 4, vesselName: 'M/V Pacific Crest', port: 'Yokohama', arrivalDate: '2026-08-05', initialAmount: 2900, negotiatedAmount: 2750, savings: 150, disbursementId: 'MDA897', type: 'pda_negotiation' },
    { id: 5, vesselName: 'M/V Atlantic Voyager', port: 'Houston', arrivalDate: '2026-08-06', initialAmount: 4800, negotiatedAmount: 4500, savings: 300, disbursementId: 'MDA898', type: 'pda_negotiation' },
    { id: 6, vesselName: 'M/V Nordic Pride', port: 'Antwerp', arrivalDate: '2026-08-07', initialAmount: 3100, negotiatedAmount: 2950, savings: 150, disbursementId: 'MDA899', type: 'pda_negotiation' },
    { id: 7, vesselName: 'M/V Southern Cross', port: 'Dubai', arrivalDate: '2026-08-08', initialAmount: 3500, negotiatedAmount: 3350, savings: 150, disbursementId: 'MDA900', type: 'pda_negotiation' },
    { id: 8, vesselName: 'M/V Coral Trader', port: 'Shanghai', arrivalDate: '2026-08-09', initialAmount: 2800, negotiatedAmount: 2700, savings: 100, disbursementId: 'MDA901', type: 'pda_negotiation' },
    { id: 9, vesselName: 'M/V Poseidon Spirit', port: 'Busan', arrivalDate: '2026-08-10', initialAmount: 3600, negotiatedAmount: 3450, savings: 150, disbursementId: 'MDA902', type: 'pda_negotiation' },
    { id: 10, vesselName: 'M/V Seagull Alpha', port: 'Piraeus', arrivalDate: '2026-08-11', initialAmount: 1800, negotiatedAmount: 1700, savings: 100, disbursementId: 'MDA903', type: 'pda_negotiation' },
    { id: 11, vesselName: 'M/V Neptune Giant', port: 'Santos', arrivalDate: '2026-08-12', initialAmount: 2100, negotiatedAmount: 1950, savings: 150, disbursementId: 'MDA904', type: 'pda_negotiation' },
    { id: 12, vesselName: 'M/V Titan Leader', port: 'Valencia', arrivalDate: '2026-08-13', initialAmount: 2000, negotiatedAmount: 1900, savings: 100, disbursementId: 'MDA905', type: 'pda_negotiation' },

    // --- FDA ITEMS (Sum of savings = $1,200) ---
    { id: 13, vesselName: 'M/V Ocean Star', port: 'Singapore', arrivalDate: '2026-08-01', initialAmount: 3200, negotiatedAmount: 3050, savings: 150, disbursementId: 'MDA894', type: 'fda_negotiation' },
    { id: 14, vesselName: 'M/V Pioneer Express', port: 'Rotterdam', arrivalDate: '2026-08-03', initialAmount: 2600, negotiatedAmount: 2500, savings: 100, disbursementId: 'MDA895', type: 'fda_negotiation' },
    { id: 15, vesselName: 'M/V Baltic Breeze', port: 'Hamburg', arrivalDate: '2026-08-04', initialAmount: 3950, negotiatedAmount: 3800, savings: 150, disbursementId: 'MDA896', type: 'fda_negotiation' },
    { id: 16, vesselName: 'M/V Pacific Crest', port: 'Yokohama', arrivalDate: '2026-08-05', initialAmount: 2750, negotiatedAmount: 2700, savings: 50, disbursementId: 'MDA897', type: 'fda_negotiation' },
    { id: 17, vesselName: 'M/V Atlantic Voyager', port: 'Houston', arrivalDate: '2026-08-06', initialAmount: 4500, negotiatedAmount: 4350, savings: 150, disbursementId: 'MDA898', type: 'fda_negotiation' },
    { id: 18, vesselName: 'M/V Nordic Pride', port: 'Antwerp', arrivalDate: '2026-08-07', initialAmount: 2950, negotiatedAmount: 2850, savings: 100, disbursementId: 'MDA899', type: 'fda_negotiation' },
    { id: 19, vesselName: 'M/V Southern Cross', port: 'Dubai', arrivalDate: '2026-08-08', initialAmount: 3350, negotiatedAmount: 3250, savings: 100, disbursementId: 'MDA900', type: 'fda_negotiation' },
    { id: 20, vesselName: 'M/V Coral Trader', port: 'Shanghai', arrivalDate: '2026-08-09', initialAmount: 2700, negotiatedAmount: 2650, savings: 50, disbursementId: 'MDA901', type: 'fda_negotiation' },
    { id: 21, vesselName: 'M/V Poseidon Spirit', port: 'Busan', arrivalDate: '2026-08-10', initialAmount: 3450, negotiatedAmount: 3350, savings: 100, disbursementId: 'MDA902', type: 'fda_negotiation' },
    { id: 22, vesselName: 'M/V Seagull Alpha', port: 'Piraeus', arrivalDate: '2026-08-11', initialAmount: 1700, negotiatedAmount: 1650, savings: 50, disbursementId: 'MDA903', type: 'fda_negotiation' },
    { id: 23, vesselName: 'M/V Neptune Giant', port: 'Santos', arrivalDate: '2026-08-12', initialAmount: 1950, negotiatedAmount: 1850, savings: 100, disbursementId: 'MDA904', type: 'fda_negotiation' },
    { id: 24, vesselName: 'M/V Titan Leader', port: 'Valencia', arrivalDate: '2026-08-13', initialAmount: 1900, negotiatedAmount: 1800, savings: 100, disbursementId: 'MDA905', type: 'fda_negotiation' },
  ];

  ngOnInit() {}

  openSavingsPopup(type: 'pda' | 'fda' | 'overall'): void {
    this.savingsPopupType = type;
    this.selectedSavingSource = null;
    this.showAllRows = false;
    this.showSavingsPopup = true;
  }

  closeSavingsPopup(): void {
    this.showSavingsPopup = false;
    this.selectedSavingSource = null;
    this.showAllRows = false;
  }

  selectSavingSource(source: 'pda_negotiation' | 'fda_negotiation'): void {
    this.selectedSavingSource = source;
    this.showAllRows = false;

    setTimeout(() => {
      this.scrollToTable();
    }, 100);
  }

  closeTable(): void {
    this.selectedSavingSource = null;
    this.showAllRows = false;
    this.scrollToTop();
  }

  scrollToTable(): void {
    if (this.tableSection && this.tableSection.nativeElement) {
      this.tableSection.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  scrollToTop(): void {
    if (this.modalContainer && this.modalContainer.nativeElement) {
      this.modalContainer.nativeElement.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  getFilteredTableData(): DisbursementItem[] {
    if (!this.selectedSavingSource) return [];
    return this.tableData.filter((item) => item.type === this.selectedSavingSource);
  }

  getDisplayedTableData(): DisbursementItem[] {
    const data = this.getFilteredTableData();
    return this.showAllRows ? data : data.slice(0, 10);
  }

  // Calculate dynamic savings total from table items
  getCalculatedCategorySavings(): number {
    return this.getFilteredTableData().reduce((acc, curr) => acc + curr.savings, 0);
  }

  toggleViewMore(): void {
    this.showAllRows = !this.showAllRows;
  }

  getSavingsPopupTitle(): string {
    switch (this.savingsPopupType) {
      case 'pda':
        return 'PDA (Proforma) Savings Insights';
      case 'fda':
        return 'FDA (Final) Savings Insights';
      default:
        return 'Overall PDA vs FDA Savings Insights';
    }
  }

  getPopupTotalSaving(): number {
    if (this.savingsPopupType === 'pda') {
      return this.savingsData.pdaSavingsAmount;
    }
    if (this.savingsPopupType === 'fda') {
      return this.savingsData.fdaSavingsAmount;
    }
    return this.savingsData.overallSavingsAmount;
  }

  getInitialDisbursement(): number {
    if (this.savingsPopupType === 'pda') {
      return 80000;
    }
    if (this.savingsPopupType === 'fda') {
      return 44995;
    }
    return this.savingsData.pdaEstimatedBudget;
  }

  getActualDisbursement(): number {
    if (this.savingsPopupType === 'pda') {
      return 76800;
    }
    if (this.savingsPopupType === 'fda') {
      return 43200;
    }
    return this.savingsData.fdaUtilizedAmount;
  }

  getSavingsPercentage(): number {
    const initial = this.getInitialDisbursement();
    const savings = this.getPopupTotalSaving();
    if (!initial || initial === 0) return 0;
    return Number(((savings / initial) * 100).toFixed(2));
  }

  getPDASavingsStrokeDashArray(): string {
    const radius = 65;
    const circumference = 2 * Math.PI * radius;
    const filled = (64 / 100) * circumference;
    return `${filled} ${circumference - filled}`;
  }

  getFDASavingsStrokeDashArray(): string {
    const radius = 65;
    const circumference = 2 * Math.PI * radius;
    const filled = (36 / 100) * circumference;
    return `${filled} ${circumference - filled}`;
  }
}